/**
 * Определяет, является ли устройство мобильным
 * Используется для оптимизации рендеринга на мобильных устройствах
 */
export const isMobile = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  // Проверяем через User Agent
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  
  // Проверяем через медиа-запросы (более надёжный способ)
  const isMobileScreen = window.matchMedia('(max-width: 768px)').matches;
  
  // Проверяем touch support
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  // Проверяем User Agent на мобильные устройства
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const isMobileUA = mobileRegex.test(userAgent);
  
  return (isMobileScreen && isTouchDevice) || isMobileUA;
};

/**
 * Проверяет, является ли браузер Chrome на Android
 * Эта комбинация имеет известные проблемы с backdrop-filter и GPU композитингом
 */
export const isChromeAndroid = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  const isAndroid = /Android/i.test(userAgent);
  const isChrome = /Chrome/i.test(userAgent) && !/Edg/i.test(userAgent);
  
  return isAndroid && isChrome;
};

